declare namespace $ {

	type $mol_view__sub_shm_ba_post_card_1 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['title_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_post_card_2 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['meta_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_post_card_3 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['tags_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_ba_post_card_4 = $mol_type_enforce<
		({ 
			'maxHeight': ReturnType< $shm_ba_post_card['text_max_height'] >,
			'overflow': string,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_ba_post_card_5 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['text_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_ba_post_card_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_ba_post_card_7 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['text_more_visible'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_ba_post_card_8 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['text_more'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_ba_post_card_9 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['metrics'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_shm_ba_post_card_10 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['url'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_ba_post_card_11 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_ba_post_card_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_button_copy__hint_shm_ba_post_card_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_ba_post_card_14 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['url'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_link__uri_shm_ba_post_card_15 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['source_url'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_ba_post_card_16 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_ba_post_card_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_button_copy__hint_shm_ba_post_card_18 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_ba_post_card_19 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['source_url'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_link__uri_shm_ba_post_card_20 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['author_url'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_shm_ba_post_card_21 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__sub_shm_ba_post_card_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_button_copy__hint_shm_ba_post_card_23 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_ba_post_card_24 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['author_url'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_view__sub_shm_ba_post_card_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_post_card_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_dimmer__haystack_shm_ba_post_card_27 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['title'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_dimmer__needle_shm_ba_post_card_28 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['highlight'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	type $mol_dimmer__haystack_shm_ba_post_card_29 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['text'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_dimmer__needle_shm_ba_post_card_30 = $mol_type_enforce<
		ReturnType< $shm_ba_post_card['highlight'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	export class $shm_ba_post_card extends $mol_view {
		title_content( ): readonly(any)[]
		Title( ): $mol_view
		meta_content( ): readonly(any)[]
		Meta( ): $mol_view
		tags_content( ): readonly(any)[]
		Tags( ): $mol_view
		text_max_height( ): string
		text_content( ): readonly(any)[]
		Text( ): $mol_view
		text_more_visible( ): boolean
		text_more( next?: any ): any
		Text_more( ): $mol_button_minor
		metrics( ): readonly(any)[]
		Metrics( ): $mol_view
		url( ): string
		source_url( ): string
		author_url( ): string
		metric_title( id: any): string
		tag_label( id: any): string
		table( ): any
		post_row( ): any
		highlight( ): string
		text( ): string
		sub( ): readonly(any)[]
		Date_link( ): $mol_link
		Date_copy( ): $shm_button_copy
		Source_link( ): $mol_link
		Source_copy( ): $shm_button_copy
		Author_link( ): $mol_link
		Author_copy( ): $shm_button_copy
		Metric( id: any): $mol_view
		Tag( id: any): $mol_view
		Title_text( ): $mol_dimmer
		Text_text( ): $mol_dimmer
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map